/** Section drawers where Quan + thought sign hide while open (waivers, start, team analysis, draft advice). */
export const STREAM_DRAWER_SECTIONS_HIDE_SIGN = [
  "waiver",
  "start",
  "rundown",
  "DraftAdvice",
] as const;

export type StreamDrawerSectionHideSign = (typeof STREAM_DRAWER_SECTIONS_HIDE_SIGN)[number];

export function shouldHideSignForStreamDrawer(
  selectedButton: string | null | undefined
): boolean {
  if (!selectedButton) return false;
  return (STREAM_DRAWER_SECTIONS_HIDE_SIGN as readonly string[]).includes(selectedButton);
}
